<template>
  <div class="mx-auto">
    <div class="minHeightMainContent flex-col">
      <div v-if="!loading">
        <PermissionSettingsCheckbox
          v-for="(val, index) in settingsArray"
          :key="index"
          class="mt-6"
          :title="index"
          :modules-array="val"
          :table-head-array="tableHeadArray"
          @updateSettings="getSettings"
        />
      </div>
      <Loader v-else class="mt-28" :content="true" />
    </div>
  </div>
</template>

<script>
/**
 * @notes IMPORTANT NOTES
 * index ACTION FOR VIEW
 * create ACTION FOR MARK
 **/
import PermissionSettingsCheckbox from '@src/components/Settings/attandance-settings/PermissionSettingsCheckbox.vue'
import { removeExtraRolePermissions } from '@utils/permissions'
import { TENANT_ROLES } from '@/src/constants/user-roles-constants'
import { mapActions, mapState } from 'vuex'
import Loader from '@/src/components/BaseComponent/Loader.vue'
export default {
  components: {
    PermissionSettingsCheckbox,
    Loader,
  },
  page: {
    title: 'System Settings | Attendance Settings',
    meta: [
      {
        name: 'description',
        content: 'Attendance Settings',
      },
    ],
  },
  props: {
    featureName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      settingsArray: [],
      tableHeadArray: ['Settings', 'View', 'Mark'],
      excludeRoleSettings: [
        TENANT_ROLES.CAMPUS_MODERATOR,
        TENANT_ROLES.SECTION_MODERATOR,
        TENANT_ROLES.SECTION_ADMIN,
      ],
    }
  },

  computed: {
    ...mapState('layout', [
      'currentCampusScope',
      'currentSectionScope',
      'currentClassScope',
      'activeRole',
    ]),
  },
  watch: {
    currentCampusScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentSectionScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentClassScope: {
      handler() {
        this.getSettings()
      },
    },
    activeRole: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
  },
  mounted() {
    this.getSettings()
  },

  methods: {
    async getSettings() {
      this.loading = true
      const [response, error] = await this.getFeaturePermissionsSettings(this.featureName)
      removeExtraRolePermissions(this.excludeRoleSettings, response.data)
      this.settingsArray = response.data
      this.loading = false
    },
    ...mapActions('settings', ['getFeaturePermissionsSettings']),
  },
}
</script>
